<template>
  <div class="centerCenter">
    <div class="container text-center">
      <router-link to="/">
        <img
          class="d-block mx-auto mb-4"
          src="../assets/logo_default.svg"
          alt
          width="100"
          height="100"
        />
      </router-link>

      <form id="signinform" class="form-signin">
        <h2 class="form-signin-heading py-3">Reset your password.</h2>

        <label for="inputUserName" class="float-left">Username or e-mail</label>
        <input
          v-bind:class="{ 'is-invalid': !usernameValid }"
          v-model="username"
          type="text"
          id="inputUserName"
          class="form-control mb-4"
          placeholder="Username"
          required
          autofocus
          @changed="usernameValid = true"
        />

        <button
          class="btn btn-lg btn-primary btn-block"
          type="submit"
          @click.prevent="submitRequest"
          v-bind:disabled="sendingRequest"
        >
          Request reset
        </button>
      </form>

      <div class="mt-3 text-small">
        Remembered your password?
        <router-link to="/login">Sign in here</router-link>
      </div>

      <slot name="footer"></slot>
    </div>
    <!-- /container -->
    <b-modal
      v-model="showModal"
      v-bind:title="modalTitle"
      @hidden="onModalHidden"
      centered
      ok-only
    >
      <p>{{ modalMessage }}</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "PasswordRequest",
  components: {},
  data() {
    return {
      username: "",
      usernameValid: true,
      showModal: false,
      modalTitle: "Error",
      modalMessage: "Something went wrong.",
      goHomeOnDismiss: false,
      sendingRequest: false
    };
  },
  created() {
    this.$emit("toggle-navbar", false);
    this.$emit("full-body", true);

    this.$topquiz.on(this, "password_reset_error", params => {
      this.showErrorModal("Error", params[0]);
      this.sendingRequest = false;
    });

    this.$topquiz.on(this, "password_reset_success", () => {
      this.goHomeOnDismiss = true;
      this.showErrorModal(
        "Request sent!",
        "If there is an account with the given username or address, a mail will be sent there shortly. Please check your mail."
      );

      localStorage.removeItem("session_key");
      this.sendingRequest = false;
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    submitRequest: function() {
      if (!this.username) {
        this.usernameValid = false;
        return;
      }

      this.sendingRequest = true;
      this.$topquiz.sendCommand("requestPasswordReset", this.username);
    },
    showErrorModal: function(title, message) {
      this.modalTitle = title;
      this.modalMessage = message;
      this.showModal = true;
    },
    onModalHidden: function() {
      if (this.goHomeOnDismiss) {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 400px;
}
</style>
